import axios from 'axios';
import { actionConst } from '../constants/expired-requests.constants';
import { buildRequestsFiltersParams } from '../containers/Requests/requests.actions';
import { authHeader } from '../helpers/auth-header';
import { client } from './';

const { CancelToken, isCancel } = axios;

export const actions = {
  getExpiredCount,
};

let cancelExpiredCount;
const cancelTokenExecutor = (cancel) => (cancelExpiredCount = cancel);
const baseUrl = '/Request/expired_requests_count';

const countPending = (fetchId) => ({
  type: actionConst.COUNT_PENDING,
  payload: fetchId,
});

const countFulFilled = (payload) => ({
  type: actionConst.COUNT_FULFILLED,
  payload,
});

const countRejected = ({ isCancel = false, fetchId }) => ({
  type: actionConst.COUNT_REJECTED,
  payload: { isCancel, fetchId },
});

function getExpiredCount({ relatedToExpired = false }) {
  if (typeof cancelExpiredCount === 'function') {
    cancelExpiredCount();
  }

  return (dispatch, getState) => {
    const queryParams = relatedToExpired
      ? buildRequestsFiltersParams(getState()) + '&applyFilter=true'
      : '';

    const fetchId = Date.now();

    dispatch(countPending(fetchId));

    client
      .get(`${baseUrl}${queryParams}`, {
        headers: authHeader(),
        cancelToken: new CancelToken(cancelTokenExecutor),
      })
      .then(
        ({ data }) => dispatch(countFulFilled({ data, fetchId })),
        (err) => dispatch(countRejected({ isCancel: isCancel(err), fetchId }))
      );
  };
}
